import { Translations } from "./translations";

export const fr: Translations = {
  nav: {
    services: "Services",
    innovation: "Innovation",
    about: "À propos",
    getInTouch: "Contactez-nous",
    openMenu: "Ouvrir le menu de navigation",
    closeMenu: "Fermer le menu de navigation",
  },
  connectedCareHero: {
    healthForAll: "La santé pour tous, ",
    anytime: "Toujours",
    anywhere: "Partout",
    fullHeadline: "La santé pour tous, Toujours Partout",
    subtitle:
      "VIDAVO développe des solutions de santé numérique qui connectent les personnes, les données et les équipes de soins pour améliorer les soins de santé quotidiens.",
    exploreServices: "Explorez nos services",
    discoverVida24: "Découvrez Vida24",
    keywords: {
      secondOpinion: "Deuxième avis",
      telemedicine: "Télémédecine",
      smartNutrition: "Nutrition intelligente",
      selfManagement: "Auto-gestion",
      digitalTherapeutics: "Thérapeutiques numériques",
      eWellness: "eBien-être",
      behaviorChange: "Changement de comportement–pleine conscience",
      mentalHealth: "Santé mentale",
    },
  },
  hero: {
    badge: "Innovation en Santé Numérique",
    title: "Votre Expert en Santé Numérique",
    subtitle:
      "De la stratégie au déploiement complet, VIDAVO accompagne chaque étape de votre parcours de santé numérique.",
  },
  trustedBy: {
    title: "L'Écosystème de Santé Numérique Vida24",
    subtitle: "Écosystème de télésanté tout-en-un pour la surveillance, l'aide à la décision et les soins intégrés.",
    description:
      "L'écosystème de santé numérique tout-en-un de VIDAVO qui réunit patients, professionnels de santé et organisations. Il permet une surveillance continue via des appareils portables et dispositifs médicaux, un partage sécurisé des données et des tableaux de bord cliniques qui soutiennent de meilleures décisions et des vies plus saines.",
    learnMore: "En savoir plus sur Vida24",
    faqTitle: "Foire aux questions",
    faqSubtitle:
      "Obtenez des réponses aux questions courantes sur les solutions et services de santé numérique de VIDAVO.",
    faqs: {
      question1: "Qu'est-ce qui différencie VIDAVO dans la santé numérique ?",
      answer1:
        "VIDAVO combine une expertise approfondie en soins de santé avec une technologie certifiée, offrant des solutions modulaires qui sont cliniquement sûres, conviviales et prêtes à être déployées à grande échelle.",
      question2: "Qu'est-ce que Vida24 ?",
      answer2:
        "Vida24 est notre écosystème de santé numérique phare. Il connecte les patients, les professionnels et les organisations grâce à la surveillance à distance, au partage sécurisé des données et à des tableaux de bord intelligents.",
      question3: "Les solutions de VIDAVO sont-elles certifiées ?",
      answer3:
        "Oui. Vida24 est certifié CE selon la Directive sur les Dispositifs Médicaux (MDD) et est actuellement en cours de certification selon le Règlement européen sur les Dispositifs Médicaux (MDR). Tous les processus et produits VIDAVO sont conformes au GDPR et soutenus par des normes de qualité et de sécurité certifiées ISO.",
      question4: "Avec qui travaillez-vous ?",
      answer4:
        "Nous travaillons avec des hôpitaux, des prestataires de soins de santé, des institutions de recherche, des municipalités et des partenaires industriels qui souhaitent mettre en œuvre des solutions de santé numérique fiables.",
      question5: "Comment soutenez-vous les clients après le déploiement ?",
      answer5:
        "Nous fournissons une formation, une assistance technique et des mises à jour continues pour garantir que les solutions restent fiables, sécurisées et efficaces dans le temps.",
      question6: "VIDAVO peut-il développer de nouvelles applications ou logiciels au-delà de Vida24 ?",
      answer6:
        "Absolument. Nous proposons Vida24 en mode SaaS, offrons des solutions en marque blanche pour les partenaires et développons des applications personnalisées adaptées aux besoins des clients.",
    },
  },
  rdMenu: {
    researchOnDemand: "Recherche sur Demande",
    rdPortfolio: "Portfolio de Projets R&D",
    buildingInnovation: "Bâtir l'Innovation",
    digitalTransformation: "Transformation Numérique",
  },
  digitalTransformation: {
    badge: 'TRANSFORMATION NUMÉRIQUE',
    title: 'Vida24',
    subtitle: 'Code du projet : 108682',
    projectTitle: 'Télémédecine Avancée & Mise à Niveau Intelligente',
    projectTitleContent: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    briefDescription: 'Description Brève',
    briefDescriptionContent: 'Investissement dans l\'évolutivité et la haute disponibilité de Vida24 en vue d\'une expansion commerciale en Europe.',
    investmentPlanBudget: "Budget du Plan d'Investissement",
    investmentPlanBudgetContent: '€430 100,00',
    investmentPlanEuFunding: 'Financement UE',
    investmentPlanEuFundingContent: '€210 875,00',
    investmentPlanDisclaimer: "Ce projet est réalisé dans le cadre du programme « Développement de Produits et de Services Numériques » du Plan National de Reprise et de Résilience Grèce 2.0, financé par l'Union Européenne – NextGenerationEU",
    logoAlt: "Grèce 2.0 Plan National de Relance et de Résilience - Financé par l'Union Européenne NextGenerationEU",
  },
  buildingInnovation: {
    badge: "CONSTRUIRE L'INNOVATION",
    title: "Les soins de santé de demain",
    subtitle:
      "Construire l'innovation signifie travailler aujourd'hui sur les solutions dont les soins de santé auront besoin demain. Grâce à nos efforts de recherche, nous explorons les technologies émergentes, validons de nouvelles méthodes et co-créons des parcours avec des partenaires académiques, cliniques et industriels. Nous accueillons les consortiums et les parties prenantes qui souhaitent faire partie de ce voyage et façonner ensemble l'avenir de la santé.",
    focusAreasTitle: "Domaines d'Innovation",
    focusAreasSubtitle:
      "Explorez nos domaines de recherche de pointe qui façonnent le paysage des soins de santé de demain",
    focusAreas: [
      "Intelligence Artificielle pour l'Aide à la Décision Clinique",
      "IA pour la Santé Publique et des Populations",
      "6G et IoT de Nouvelle Génération",
      "Jumeaux Numériques en Santé",
      "Réalité Étendue (VR/AR/MR)",
      "Biomarqueurs Numériques et Télédétection",
      "Technologies de Santé Durables et Vertes",
      "Interopérabilité et Confiance des Données",
    ],
    partnerTitle: "Partenariat avec Nous",
    partnerSubtitle: "Rejoignez notre écosystème de partenaires d'innovation façonnant l'avenir de la santé",
    partners: {
      academic: {
        title: "Partenaires Académiques",
        description: "Universités et institutions de recherche à l'origine de découvertes révolutionnaires",
      },
      healthcare: {
        title: "Prestataires de Soins",
        description: "Hôpitaux et cliniques mettant en œuvre des solutions concrètes",
      },
      industry: {
        title: "Leaders de l'Industrie",
        description: "Entreprises technologiques et innovateurs en santé",
      },
    },
  },
  researchOnDemand: {
    badge: "SOLUTIONS R&D",
    title: "Recherche sur Demande",
    subtitle: "Transformer les questions en résultats",
    description:
      "La recherche devient précieuse lorsqu'elle répond à de vrais besoins. Chez Vidavo, nous concevons et exécutons des études qui génèrent des informations pratiques pour la santé, l'industrie et les politiques publiques. Notre approche combine la rigueur scientifique avec un accent clair sur l'applicabilité, garantissant que chaque projet fournit des résultats pouvant guider les décisions, façonner de nouvelles solutions ou valider des produits.",
    whatWeOffer: "Ce que nous offrons",
    services: [
      {
        title: "Conception d'études sur mesure",
        description:
          "Des études pilotes à petite échelle aux essais multicentriques, nous planifions des études adaptées aux objectifs et aux ressources de nos partenaires.",
      },
      {
        title: "Validation clinique",
        description:
          "Expertise en protocoles qui évaluent la sécurité, la performance et l'utilisabilité des technologies de santé numérique dans des contextes réels.",
      },
      {
        title: "Recherche utilisateur et de marché",
        description:
          "Collecte et analyse des retours des patients, cliniciens et organisations de santé pour éclairer le développement de produits.",
      },
      {
        title: "Gestion et analyse des données",
        description:
          "Infrastructures sécurisées pour collecter, traiter et interpréter les données de santé avec transparence et conformité.",
      },
      {
        title: "Cadres d'évaluation",
        description:
          "Développement de KPI et de mesures de résultats qui démontrent la valeur en termes cliniques, économiques ou sociaux.",
      },
    ],
    globalNetwork: {
      badge: "PRÉSENCE MONDIALE",
      title: "Réseau de recherche mondial",
      description:
        "Nos projets de recherche s'étendent sur plusieurs pays, créant un réseau complet d'innovation en santé et de collaboration scientifique qui favorise l'avancement de la santé mondiale.",
    },
    trackRecord: {
      title: "Notre bilan",
      description:
        "Au cours des deux dernières décennies, nous avons soutenu des projets de recherche européens et nationaux, collaboré avec des universités et des hôpitaux dans plusieurs pays, et travaillé avec des entreprises privées pour amener de nouvelles technologies de santé du concept au déploiement. Notre rôle a varié de la coordination scientifique et des essais cliniques au développement technologique et à l'évaluation d'impact.",
    },
    stats: [
      { label: "Années d'expérience" },
      { label: "Projets de recherche européens et nationaux" },
      { label: "Partenaires académiques et cliniques dans le monde" },
      { label: "Pays avec implémentations de projets" },
    ],
  },
  euNationalProjects: {
    badge: "PROJETS UE/NATIONAUX",
    title: "Portfolio de projets récents",
    subtitle: "Notre portfolio complet de projets de recherche achevés et en cours à travers l'Europe.",
    projectDescriptions: {
      marissa:
        "Un projet Horizon 2020 qui développe une plateforme numérique pour améliorer la gestion du diabète de type II et de la sarcopénie chez les personnes âgées grâce à des soins personnalisés, une surveillance à distance et l'autonomisation des patients.",
      raise:
        "Un projet Horizon 2020 qui développe des solutions de télé-rééducation, permettant aux patients dans les zones éloignées d'accéder à des soins continus et de gérer les maladies chroniques via le système Vida24, des dispositifs médicaux connectés et un support à distance.",
      valueCare:
        "Un projet Horizon 2020 qui fournit une solution numérique intégrée pour soutenir les personnes âgées atteintes de maladies chroniques, combinant services de santé et services sociaux pour améliorer la qualité de vie et l'efficacité des soins.",
      intelliot:
        "Un projet Horizon 2020 qui développe des solutions IoT de nouvelle génération pour la santé, l'agriculture et l'industrie manufacturière, avec Vidavo contribuant au soutien numérique centré sur le patient et à la surveillance de santé à distance.",
      inspect:
        "Un projet cofinancé par l'UE et des ressources nationales qui développe des lits d'hôpital intelligents avec capteurs intégrés pour surveiller en continu les patients, détecter les risques sanitaires précoces et prévenir les complications telles que les escarres.",
      pat: "Un projet financé dans le cadre du Programme opérationnel grec «Compétitivité et Entrepreneuriat» qui a développé un système numérique pour la surveillance continue et la détection précoce des maladies respiratoires allergiques, aidant patients et médecins à gérer les symptômes et améliorer la qualité de vie.",
      intelTriage:
        "Un projet qui développe un système intelligent de triage et de surveillance pour les services d'urgence hospitaliers, utilisant des biocapteurs et des outils d'aide à la décision pour prioriser les soins et suivre les patients pendant leurs premières 24 heures d'admission.",
      liver3d:
        "Un projet de recherche cofinancé par l'UE et des ressources nationales qui développe des modèles d'organes imprimés en 3D pour soutenir la planification et la formation chirurgicales, améliorant la précision et la sécurité des procédures médicales.",
      sefac:
        "Un projet financé par l'UE qui promeut la prévention et l'autogestion des maladies chroniques en impliquant citoyens, prestataires de soins de santé et bénévoles dans des activités communautaires et des programmes soutenus par les TIC dans quatre régions pilotes européennes.",
      cyberCare:
        "Un projet cofinancé par l'UE et des ressources nationales qui développe un système de cybersécurité pour protéger les réseaux de santé et les dispositifs médicaux connectés, validé par un projet pilote de soins de grossesse à distance en Grèce.",
      im: "Une plateforme numérique pour gérer les patients en oncologie et les protocoles de chimiothérapie, fournissant automatisation, rapidité et sécurité à toutes les étapes du traitement. Le projet «IM» a été mis en œuvre dans le cadre de l'Action «Plans d'Investissement de l'Innovation» du Programme «Macédoine Centrale», PARD 2021-2027», qui est cofinancé par l'Union Européenne et la Grèce",
      smartcare:
        "Un projet européen qui a développé des parcours de soins soutenus par les TIC pour intégrer services de santé et services sociaux, piloté dans dix régions en Europe pour améliorer la coordination et la prestation de soins centrés sur le citoyen.",
      evolve2care:
        "Financé par l'Union européenne, EVOLVE2CARE fait progresser l'expérimentation HealthTech afin de renforcer la collaboration entre les Living Labs et les innovateurs dans le domaine des soins de transition. Le projet soutient la mise à l'échelle de la plateforme Vida24 de VIDAVO, une solution de santé numérique certifiée CE pour la gestion des maladies chroniques, à travers un pilote de validation non clinique. En collaboration avec le Good Tech Living Lab en Roumanie, il se concentre sur la validation en conditions réelles de l'utilisabilité, de l'engagement des patients, de l'adéquation au flux de travail clinique et du déploiement éthique.",
      cyberSuite:
        "CyberSuite est un projet Digital Europe qui soutient les PME dans l'adoption de solutions avancées de cybersécurité via une plateforme intégrée Security-as-a-Service et une marketplace. VIDAVO dirige le cas d'usage Santé Numérique via sa plateforme Vida24®, en soutenant la validation des solutions CyberSuite dans un environnement de santé réel, avec un accent sur la surveillance de la cybersécurité, l'évaluation des vulnérabilités et le renforcement de la cyber-résilience des plateformes de télésanté.",
      cerebris:
        "CEREBRIS est un projet EIC Pathfinder développant un écosystème d'IA sécurisé et explicable pour la prise en charge de l'AVC et la gestion des maladies neurologiques. En combinant données cliniques, imagerie cérébrale, biosignaux et modèles d'IA avancés, le projet soutient une rééducation et une prédiction de la récupération plus personnalisées. VIDAVO contribue en tant que partenaire de la plateforme de santé numérique, en soutenant l'interopérabilité, la capture des données et l'intégration au sein de l'écosystème CEREBRIS.",
      default:
        "Un projet innovant de technologie de santé contribuant à la transformation de la santé numérique et à l'amélioration de la prestation de soins aux patients.",
    },
    seeMore: "Voir plus",
    tapToFlip: "Appuyez pour les détails",
  },
  aboutMenu: {
    vidavoEU: 'Vidavo EU',
    vidavoIndia: 'VIDAVO Asie',
    vidavoThroughTime: "Vidavo à travers le temps",
    whyUs: "Pourquoi Nous",
    investorRelations: "Relations Investisseurs",
    careers: "Carrières",
    vida24HomeCare: 'Vida24 pour les Soins à Domicile',
  },
  vidavoMiddleEast: {
    pageTitle: 'VIDAVO Middle East | Soins connectés et santé numérique IA',
    metaDescription: 'VIDAVO apporte des solutions de soins connectés et de santé numérique pilotées par l\'IA au Moyen-Orient via la plateforme VIDA24 et des services de développement IA pour la santé.',
    badge: 'VIDAVO Moyen-Orient',
    aiBadge: 'IA',
    heroTitle: 'VIDAVO – Faire progresser la santé numérique par les soins connectés et l\'innovation IA',
    heroSubtitle: 'La santé pour tous, à tout moment, partout',
    heroLead: 'Transformer les soins de santé grâce aux soins connectés',
    heroText: 'VIDAVO est une entreprise de santé numérique dédiée à la transformation de la prestation de soins par des solutions innovantes de soins connectés. Notre mission : rendre la santé plus accessible, plus efficace et centrée sur le patient, en permettant des services de santé à tout moment et partout.',
    platformTitle: 'La plateforme de santé numérique VIDA24',
    platformText: 'Au cœur de notre écosystème se trouve VIDA24, une plateforme de santé numérique modulaire et évolutive qui prend en charge la télésurveillance des patients, la télémédecine, la gestion des maladies chroniques, les services de soins virtuels et les parcours de soins intégrés.\n\nDans un environnement unifié, VIDA24 relie professionnels de santé, patients et dispositifs médicaux, permettant communication en temps réel, surveillance et aide à la décision clinique.',
    platformCta: 'Visiter vida24.eu',
    aiTitle: 'Solutions de santé propulsées par l\'IA',
    aiText1: 'L\'intelligence artificielle fait désormais partie intégrante de la santé moderne, et VIDAVO intègre activement des capacités d\'IA dans ses solutions. Les technologies d\'IA soutiennent l\'analyse des données, l\'évaluation des risques, la surveillance des patients, la décision clinique et l\'optimisation des flux de travail, aidant les organisations de santé à améliorer leur efficacité et les résultats pour les patients.',
    aiText2: 'Au-delà des solutions de plateforme, VIDAVO propose également des services de développement IA en santé, accompagnant organisations, prestataires et partenaires dans la conception, le développement et l\'intégration d\'applications de santé numérique fondées sur l\'IA et adaptées à leurs besoins. En combinant expertise médicale, innovation numérique et technologies avancées, nous accélérons leur transformation numérique.',
    futureTitle: 'Façonner l\'avenir de la santé numérique',
    futureText: 'Forte d\'une longue expérience en santé numérique, télémédecine et soins connectés, VIDAVO continue d\'accompagner les systèmes et organisations de santé vers des services plus intelligents, plus proactifs et plus accessibles.',
    ctaTitle: 'Construisons ensemble les soins connectés',
    ctaText: 'Échangez avec notre équipe sur les initiatives de santé numérique et d\'IA au Moyen-Orient.',
    ctaButton: 'Contactez-nous',
    readInArabic: 'Read this page in Arabic',
    tapToZoom: 'Appuyez pour zoomer',
    heroImageAlt: 'Professionnel de santé utilisant une tablette dans un environnement numérique de soins connectés.',
    applicationImageAlt: 'Application VIDA24 affichant les signes vitaux, le plan de soins et la télésurveillance santé.',
  },
  vidavoIndia: {
    pageTitle: 'VIDAVO Asie | Soins connectés et santé numérique en Inde',
    metaDescription: 'VIDAVO Asia apporte plus de 25 ans d\'expérience en santé numérique et la plateforme VIDA24 en Inde, alliant technologie éprouvée et expertise locale.',
    badge: 'VIDAVO Asia',
    heroTitle: 'Apporter les Soins Connectés en Inde',
    heroText: 'VIDAVO Asia apporte en Inde les 25+ années d\'expérience de VIDAVO en santé numérique ainsi que la plateforme VIDA24, combinant une technologie éprouvée à l\'international et une expertise locale pour soutenir la transformation numérique de la santé.',
    heroImageAlt: 'La plateforme de santé numérique VIDA24 connecte les soins à travers l\'Inde',
    whoWeAreTitle: 'VIDAVO Asia : Expérience Mondiale, Expertise Locale',
    whoWeAreText: 'VIDAVO Asia représente VIDAVO S.A. en Inde, apportant plus de 25 ans d\'expérience en santé numérique et en soins connectés à l\'un des marchés de la santé à la croissance la plus rapide au monde.\n\nEn partenariat avec Mc&Me Techserve Pvt. Ltd., VIDAVO Asia combine des solutions de santé numérique éprouvées à l\'international avec une expertise locale pour répondre aux besoins évolutifs des organisations de santé à travers l\'Inde.',
    platformLabel: 'VIDA24',
    platformTitle: 'Une Plateforme. De Multiples Possibilités.',
    platformText: 'VIDA24 est la plateforme de santé numérique modulaire et interopérable de VIDAVO, conçue pour relier patients, professionnels de santé et organisations de santé tout au long du continuum de soins.\n\nDe la télésurveillance des patients et la télémédecine à la gestion des maladies chroniques et la coordination des soins, VIDA24 permet des soins plus connectés, plus efficaces et centrés sur le patient.',
    demoButton: 'Demander une Démo',
    solutionsTitle: 'Nos Solutions',
    solutions: [
      { title: 'Soins Connectés', description: 'Des soins continus et coordonnés dans tous les environnements.' },
      { title: 'Télésurveillance des Patients', description: 'Une surveillance connectée au-delà des murs de l\'hôpital.' },
      { title: 'Télémédecine & Soins Virtuels', description: 'Un accès à distance aux professionnels et services de santé.' },
      { title: 'Gestion des Maladies Chroniques', description: 'Un accompagnement continu des pathologies de longue durée.' },
      { title: 'Coordination des Soins', description: 'Relier les équipes pluridisciplinaires tout au long du parcours patient.' },
    ],
    innovationTitle: 'Innovation Numérique Propulsée par l\'IA',
    innovationText: 'VIDA24 intègre des capacités d\'IA pour l\'analyse intelligente des données, l\'identification des risques, l\'optimisation des flux de travail et une aide avancée à la décision — soutenant les professionnels de santé tout en gardant l\'humain au centre des soins.',
    experienceTitle: 'Expérience Internationale. Perspective Locale.',
    experienceText: 'Depuis plus de 25 ans, VIDAVO collabore avec des hôpitaux, des organisations de santé, des instituts de recherche, des partenaires industriels et des autorités publiques pour développer et déployer des solutions de santé numérique innovantes.\n\nÀ travers VIDAVO Asia, cette expérience se conjugue à une expertise locale pour soutenir les besoins évolutifs de l\'écosystème de santé indien.',
    discoverTitle: 'Découvrez VIDAVO Asia',
    discoverText: 'Découvrez comment VIDAVO Asia et nos solutions de soins connectés peuvent accompagner les organisations de santé en Inde.',
    contactButton: 'Contactez notre Équipe',
    ctaEmail: 'india.remotecare@vidavo.eu',
  },
  vidavoEU: {
    badge: 'PROJETS UE',
    title: 'Vidavo – La santé partout et à tout moment, désormais aussi en Europe !',
    titlePart1: 'Vidavo – La santé partout et à tout moment,',
    titleHighlight: 'désormais aussi en Europe !',
    subtitle: 'Avec Vidavo EU à Liège, en Belgique, nous franchissons la première étape de notre expansion internationale, en apportant nos solutions de santé numérique aux organisations de soins de santé à travers l\'Europe.',
    ctaButton: 'Contactez-nous pour collaborer',
    section1Title: 'Pourquoi Liège ? Pourquoi l\'Europe ?',
    section1Intro: 'Liège est un point stratégique pour la croissance européenne de Vidavo, offrant un accès direct à de nouvelles opportunités de collaboration dans le domaine de la santé ainsi qu\'un environnement favorable à l\'innovation en santé numérique. Grâce à Vidavo EU, nous posons les bases de notre présence internationale et ouvrons de nouvelles perspectives de partenariats avec des organisations de santé à travers l\'Europe, autour des piliers suivants.',
    section1Cards: {
      card1Title: 'Développement de collaborations et de réseaux',
      card1Desc: '',
      card2Title: 'Déploiement des solutions Vidavo – Healthcare Anytime Anywhere sur de nouveaux marchés',
      card2Desc: '',
      card3Title: 'Initiatives internationales en santé numérique',
      card3Desc: '',
    },
    section2Title: 'Bureaux Vidavo EU',
    section2Subtitle: 'Notre nouvelle implantation européenne',
    section2AddressLabel: 'Adresse :',
    section2Address: 'Quai sur-Meuse 19, 4000 Liège, Belgique',
    section2EmailLabel: 'E-mail :',
    section2Email: 'VidavoEU@vidavo.eu',
    section2Footer: 'Le bureau de Liège fait désormais partie du réseau des sites Vidavo et constitue le point de départ de la présence paneuropéenne de l\'entreprise.',
    vida24Title: 'Vida24 : Un écosystème de santé numérique complet',
    vida24Intro: 'Au cœur des solutions Vidavo se trouve Vida24, un écosystème complet de santé numérique conçu pour les soins à distance et la gestion des flux de travail cliniques, qui permet :',
    vida24Benefits: [
      'Une meilleure organisation et fluidité des processus médicaux',
      'Une communication améliorée entre les professionnels de santé et les patients',
      'Un accès sécurisé et immédiat aux informations de santé'
    ],
    vida24Closing: 'Avec Vida24, nous rendons les services de santé plus accessibles — à tout moment, partout — en plaçant les personnes au cœur du système.',
    euroCollabTitle: 'Développer de nouvelles collaborations en Europe',
    euroCollabDescription: 'Vidavo EU renforce notre présence en Europe grâce à des partenariats ciblés, au déploiement de technologies de santé numérique et à des synergies avec des organisations de santé et d\'innovation technologique. L\'entreprise étend déjà son réseau de collaborations en Europe.',
    euroCollabNote: 'Partenariat stratégique avec FHC+P GmbH',
    getInTouchTitle: 'Contactez Vidavo EU',
    getInTouchDescription: 'Êtes-vous une organisation de santé, une institution ou une entreprise intéressée par des opportunités de collaboration et de développement international ?',
    getInTouchSubtext: 'Contactez-nous pour explorer les possibilités de projets, de partenariats ou de déploiements pilotes.',
    getInTouchCTA: 'Contactez-nous pour collaborer',
  },
  vidavo: {
    badge: "HISTOIRE DE L'ENTREPRISE",
    title: "VIDAVO à travers le temps",
    subtitle:
      "Depuis notre fondation en 2002 jusqu'à notre expansion mondiale aujourd'hui, explorez les jalons qui ont façonné le parcours de VIDAVO dans la révolution de la santé numérique.",
    timeline: {
      event2025: "Levée de fonds – Notre écosystème de partenaires est en cours d'établissement dans le monde entier",
      event2024: "Vida24 Assurtech",
      event2023: "Sensibilisation et formation des patients activées par l'IA",
      event2021: "Système de support de triage intelligent Vida24",
      event2020: "Vida24 reconnu parmi les meilleures plateformes de santé dans le monde",
      event2019: "Expansion au-delà de l'UE",
      event2015: "Brevet : Plateforme interactive pour la maladie d'Alzheimer",
      event2014: "Logiciel Vida24 certifié comme dispositif médical",
      event2011: "Brevet : Bracelet bouton panique GPS",
      event2010: "Coté en bourse au marché alternatif (ΕΝ.Α. Growth) d'Euronext Athens, levée de fonds par placement privé",
      event2007: "Brevet : Dispositif médical IoT",
      event2005: "Levée de capital d'amorçage Thermi SA, lancement commercial de Vida24 (Mobinet Wellness)",
      event2002: "Société créée par Dr. Pantelis Angelidis, Ingénieur Électrique",
    },
    buildingFuture: {
      title: "Construire l'Avenir",
      description:
        "Notre voyage se poursuit alors que nous repoussons les limites de l'innovation en matière de santé numérique, en connectant les patients et les prestataires du monde entier grâce à une technologie de pointe et des solutions de soins compatissantes.",
    },
  },
  whyUs: {
    badge: "POURQUOI NOUS CHOISIR",
    title: "Pourquoi Nous Choisir",
    subtitle:
      "Découvrez ce qui nous distingue dans l'industrie de la santé numérique grâce à notre expertise éprouvée, notre engagement envers l'excellence et notre dévouement inébranlable à l'innovation.",
    advantages: [
      {
        title: "Expertise",
        description:
          "Notre équipe combine connaissances scientifiques, compétences techniques et état d'esprit entrepreneurial pour fournir des services de haute qualité, de la mise en œuvre au support à long terme.",
      },
      {
        title: "Plus de 25 ans d'expérience",
        description:
          "Nous façonnons la santé numérique depuis plus de deux décennies, en apportant des connaissances de recherche dans des solutions e/mHealth du monde réel.",
      },
      {
        title: "Accréditations",
        description:
          "Nos opérations suivent des normes internationalement reconnues pour la gestion de la qualité, la sécurité des dispositifs médicaux, les pratiques de laboratoire, la conformité anti-corruption et la sécurité de l'information sur la confidentialité, reflétant notre engagement à créer des solutions de santé numérique avec le plus haut niveau de confiance et de fiabilité.",
      },
      {
        title: "Solutions certifiées",
        description:
          "La suite Vida24 est certifiée CE Classe IIa selon la directive 93/42 CEE, répondant aux exigences réglementaires européennes strictes.",
      },
      {
        title: "Protection des données",
        description:
          "Nous sommes enregistrés auprès de l'Autorité Hellénique de Protection des Données et entièrement conformes au GDPR, protégeant les informations personnelles sensibles de santé.",
      },
      {
        title: "Sécurité",
        description:
          "Nos plateformes sont hébergées sur des infrastructures conformes à la norme ISO 27001, avec des configurations redondantes pour la fiabilité et la résilience.",
      },
    ],
    unGlobalCompact: {
      title: "Engagement envers les Principes Mondiaux",
      description:
        "Nous sommes fiers de participer au Pacte Mondial des Nations Unies, alignant notre stratégie et nos opérations sur ses Dix Principes relatifs aux droits de l'homme, au travail, à l'environnement et à la lutte contre la corruption. Cet engagement reflète notre dévouement aux pratiques commerciales responsables et au développement durable, garantissant que notre innovation contribue à un impact mondial positif.",
      pillars: {
        humanRights: "Droits de l'Homme",
        labour: "Travail",
        environment: "Environnement",
        antiCorruption: "Anti-Corruption",
      },
    },
    finalStatement: {
      title: "Pourquoi nous faire confiance",
      description:
        "Nos solutions sont certifiées, scientifiquement validées, largement testées à grande échelle, éprouvées sur le marché et déjà opérationnelles dans divers contextes commerciaux, approuvées par un large éventail de parties prenantes.",
    },
  },
  scrollCarousel: {
    steps: {
      step1: {
        title: "Votre Expert en Santé Numérique de Confiance",
        description: "Services de santé numérique fondés sur des preuves avec un impact réel.",
      },
      step2: {
        title: "Conseil",
        description: "Découverte, évaluation des besoins et feuille de route claire pour la santé numérique.",
      },
      step3: {
        title: "Conception",
        description: "UX centrée sur l'humain et flux de travail de qualité clinique.",
      },
      step4: {
        title: "Développer / Intégrer",
        description: "Modules interopérables et intégrations sécurisées avec les systèmes existants.",
      },
      step5: {
        title: "Personnaliser / SaaS",
        description: "Fonctionnalités configurables et livraison cloud évolutive.",
      },
      step6: {
        title: "Former",
        description: "Formation pratique pour les cliniciens, les administrateurs et les utilisateurs finaux.",
      },
      step7: {
        title: "Support",
        description: "Support SLA continu, surveillance et mises à jour.",
      },
      step8: {
        title: "Mise à l'échelle",
        description: "Du pilote à la production avec gouvernance et KPI.",
      },
    },
  },
  collaboratorsCarousel: {
    title: "Nos Produits",
    subtitle: "Solutions VIDAVO essentielles qui forment l'épine dorsale de notre écosystème de santé numérique.",
    products: {
      vida24: "Tableau de bord de soins connectés",
      vida24Healthcare: "2ème avis aux médecins généralistes",
      vida24Monitoring: "Gestion de la santé des patients",
      vidAware: "Intégration de montres intelligentes",
      vidATrack: "Suivi d'urgence et de localisation",
      vida24Marine: "Support de télémédecine pour navires de croisière",
      vida: "Support thérapeutique",
      vida24Vet: "Gestion de la santé vétérinaire",
    },
  },
  processFlow: {
    steps: {
      step1: {
        title: "Conseil",
        description:
          "Nous commençons par comprendre vos besoins, définir les objectifs et façonner une stratégie claire de santé numérique.",
      },
      step2: {
        title: "Conception",
        description:
          "Nous transformons les exigences en conceptions centrées sur l'utilisateur, garantissant l'utilisabilité, la sécurité clinique et la conformité dès le début.",
      },
      step3: {
        title: "Développer & Intégrer",
        description:
          "Nous construisons des solutions de santé numérique fiables et les connectons aux infrastructures informatiques existantes, aux dispositifs médicaux et aux systèmes hospitaliers.",
      },
      step4: {
        title: "Personnaliser / SaaS / Marque blanche",
        description:
          "Nous fournissons des solutions sous forme de SaaS, proposons des déploiements en marque blanche à nos partenaires ou personnalisons des applications pour des flux de travail spécifiques.",
      },
      step5: {
        title: "Former",
        description:
          "Nous proposons des formations aux professionnels et au personnel de santé afin de garantir une adoption en toute confiance et une utilisation quotidienne des nouveaux outils numériques.",
      },
      step6: {
        title: "Support",
        description:
          "Nous offrons un support technique continu pour maintenir les systèmes fiables, sécurisés et continuellement mis à jour.",
      },
      step7: {
        title: "Mise à l'échelle",
        description:
          "Nous aidons à transformer les projets pilotes en déploiements à grande échelle, en nous adaptant aux nouvelles exigences et en favorisant une croissance durable.",
      },
    },
  },
  footer: {
    partnerText:
      "Nous collaborons avec des partenaires et des revendeurs agréés qui partagent notre vision pour faire progresser la santé numérique.",
    becomePartner: "Devenir partenaire",
    ourOffices: "Nos Bureaux",
    thessalonikiHQ: "Thessaloniki HQ",
    thessalonikiAddress: "10th km Thessalonikis - N. Moudanion,",
    thessalonikiAddress2: "Balkan Center, Building D, 57001",
    athens: "Athènes",
    athensAddress: "Priinis 4, Nea Smyrni, 17122",
    ioannina: "Ioannina",
    ioanninaAddress: "Parc Scientifique et Technologique d'Épire, 45500",
    vidavoEU: "Vidavo EU – Liège, Belgique",
    vidavoEUAddress: "Quai sur - Meuse 19, 4000 Liège, Belgique",
    callUsAt: "Appelez-nous au",
    emailUsAt: "Écrivez-nous à",
    followUs: "Suivez-nous",
    copyright: "© 2025 VIDAVO.",
    allRightsReserved: "Tous droits réservés.",
    personalData: "Données personnelles",
    cookieNotice: "Avis sur les cookies",
    backToTop: "Retour en haut",
    aboutVidavo: "En savoir plus sur Vidavo",
  },
  services: {
    hero: {
      title: "Nos Services",
      subtitle:
        "Solutions de santé numériques complètes couvrant la télémédecine, le bien-être, les systèmes de santé intelligents et les services de conseil stratégique.",
    },
    categories: {
      telemedicine: {
        title: "Télémédecine & Soins Solutions",
        description:
          "Des soins à distance qui connectent les patients et les prestataires à tout moment, n'importe où.",
        services: [
          {
            title: "Télémédecine pour Maladies Chroniques",
            description: "Surveillance et gestion à distance des maladies chroniques",
          },
          {
            title: "Clinique Ambulatoire Numérique",
            description: "Consultations virtuelles et services de santé numériques",
          },
          {
            title: "Urgence & Bouton Panique",
            description: "Réponse d'urgence immédiate et systèmes d'alerte panique",
          },
          {
            title: "Suivi & Soutien de Grossesse",
            description: "Solutions complètes de soins et de surveillance de grossesse",
          },
          {
            title: "Soutien en Santé Mentale",
            description: "Services complets de santé mentale et de bien-être psychologique",
          },
          {
            title: "Télémédecine Maritime",
            description: "Solutions de santé pour les environnements maritimes et isolés",
          },
        ],
      },
      wellness: {
        title: "Bien-être & Santé Préventive",
        description: "Outils et programmes qui soutiennent des modes de vie plus sains et une intervention précoce.",
        services: [
          {
            title: "Solutions de Changement Comportemental",
            description: "Programmes fondés sur des preuves pour des changements de mode de vie durables",
          },
          {
            title: "Bien-être en Entreprise",
            description: "Programmes de bien-être des employés et solutions de santé au travail",
          },
          {
            title: "Bien-être Scientifique",
            description: "Interventions de bien-être et protocoles validés par la recherche",
          },
          {
            title: "eSanté & Tourisme de Bien-être",
            description: "Solutions de santé numérique pour les voyages et le tourisme de bien-être",
          },
        ],
      },
      smartHealth: {
        title: "HealthTech Nouvelle Génération",
        description: "Technologies intelligentes transformant les données en informations de santé exploitables.",
        services: [
          {
            title: "Assurtech",
            description: "Solutions technologiques d'assurance pour la couverture santé",
          },
          {
            title: "Thérapeutiques Numériques & Pharma",
            description: "Interventions thérapeutiques fondées sur des preuves via des plateformes numériques",
          },
          {
            title: "Santé Animale Numérique",
            description: "Télémédecine vétérinaire et surveillance de la santé animale",
          },
          {
            title: "Analyses Éco-Santé",
            description: "Solutions de surveillance et d'analyse de la santé environnementale",
          },
          {
            title: "Aide à la Décision par IA",
            description: "Intelligence artificielle pour l'aide à la décision clinique",
          },
          {
            title: "Aide à la décision GHM",
            description: "Classification et systèmes d'optimisation des Groupes Homogènes de Malades",
          },
        ],
      },
      advisory: {
        title: "Stratégie & Conseil",
        description:
          "Conseils d'experts pour concevoir, mettre en œuvre et faire évoluer les initiatives de santé numérique.",
        services: [
          {
            title: "Conseil en Santé Numérique",
            description: "Conseil stratégique pour la transformation numérique des soins de santé",
          },
        ],
      },
    },
    servicesAvailable: "Services Disponibles",
    cta: {
      title: "Prêt à Transformer les Soins de Santé ?",
      description:
        "Découvrez comment nos solutions de santé numériques complètes peuvent révolutionner votre prestation de soins de santé et améliorer les résultats pour les patients.",
      scheduleConsultation: "Planifier une Consultation",
    },
  },
  chronicConditionManagement: {
    title: "Gestion des maladies chroniques",
    subtitle:
      "Solutions numériques complètes pour gérer les problèmes de santé chroniques avec une surveillance continue et des plans de soins personnalisés.",
    ourApproach: {
      title: "Notre approche",
      description:
        "Nous fournissons des solutions de santé intégrées qui aident les patients et les professionnels de santé à gérer les maladies chroniques plus efficacement grâce à une technologie avancée et des protocoles de soins personnalisés.",
    },
    keyFeatures: {
      title: "Fonctionnalités clés",
      features: [
        "Surveillance de la santé et alertes en temps réel",
        "Plans de traitement personnalisés",
        "Gestion des médicaments et rappels",
        "Évaluations de santé régulières",
        "Coordination des professionnels de santé",
        "Ressources d'éducation et de soutien pour les patients",
      ],
    },
    conditionsWeSupport: {
      title: "Pathologies que nous prenons en charge",
      description:
        "Notre plateforme prend en charge la gestion de diverses pathologies chroniques, notamment le diabète, l'hypertension, les maladies cardiaques, la BPCO et d'autres problèmes de santé à long terme nécessitant des soins et une surveillance continus.",
    },
  },
  serviceModal: {
    title: "Détails du service",
    description:
      "Informations détaillées sur le service sélectionné, y compris médias, description et fonctionnalités.",
    altTexts: {
      mobileHealthApp:
        "Application mobile de surveillance de la santé montrant les lectures d'oxymétrie et le suivi d'activité",
      insurtechDashboard: "Tableau de bord Assurtech affichant l'analyse et la gestion des assurances",
      ecoHealthDashboard:
        "Tableau de bord Eco-Health Analytics montrant les corrélations entre données environnementales et de santé",
      digitalAnimalHealth:
        "Plateforme de santé animale numérique présentant le tableau de bord vétérinaire et la gestion des demandes",
      aiDecisionSupport:
        "Application mobile d'aide à la décision IA montrant le scan sans contact des signes vitaux et l'analyse de santé",
      digitalHealthConsulting:
        "Feuille de route stratégique de conseil en santé numérique montrant objectifs, normes et résultats",
      scientificWellness:
        "Application mobile Scientific Wellness présentant la surveillance du sommeil et de la fréquence cardiaque avec visualisation des données",
      ehealthWellnessTourism:
        "Application mobile eHealth & Wellness Tourism présentant le mode exercice avec minuterie et suivi de progression",
    },
    specificDescriptions: {
      insurtech:
        "La transformation numérique remodèle l'assurance, déplaçant l'accent de la gestion des sinistres vers la santé proactive et la valeur client à long terme.",
      ecoHealth:
        "Les conditions environnementales façonnent la santé humaine. L'analyse Eco-Health révèle ces liens en combinant informations environnementales et cliniques pour dévoiler des modèles, prédire les risques et guider des décisions plus intelligentes pour les villes et l'industrie.",
      aiDecisionSupport:
        "L'intelligence artificielle intervient en tant que partenaire clinique. D'un scan rapide par caméra des signes vitaux aux prédictions guidant les soins, elle transforme les données brutes en soutien actionnable pour les médecins et les patients.",
      digitalHealthConsulting:
        "Les organisations de santé, municipalités et assureurs sont sous pression pour se moderniser avec des outils numériques, mais la complexité des réglementations, de l'interopérabilité et de la gestion du changement rend cela difficile. Nos services de conseil aident à naviguer cette transition avec clarté et stratégie.",
      scientificWellness:
        "La prévention entre dans l'ère de la précision. Le bien-être scientifique intègre données génétiques, biomarqueurs et métriques de santé numériques pour créer des stratégies de bien-être individualisées ancrées dans la science.",
      ehealthWellnessTourism:
        "Le tourisme et la santé se croisent de nouvelles façons. Le tourisme eHealth et bien-être combine bilans préventifs et programmes de bien-être avec des expériences de voyage, offrant aux visiteurs un suivi numérique à long terme après leur séjour.",
    },
  },
  serviceData: {
    chronicDiseaseTelemedicine: {
      description:
        "Outils numériques pour la gestion continue des maladies chroniques, permettant aux patients de vivre une vie plus saine tandis que les professionnels de santé peuvent surveiller, intervenir et adapter les soins à distance.",
      features: [
        {
          title: "Dossier de santé",
          description:
            "Fichier médical personnalisé avec profil, historique, enregistrements de signaux biologiques, médicaments, et plus.",
        },
        {
          title: "Télémétrie",
          description: "Surveillance sans fil des signes vitaux avec transmission cloud en temps réel",
        },
        {
          title: "Alertes et notifications",
          description: "Alertes personnalisées, rappels et notifications pour les patients et les cliniciens",
        },
        {
          title: "Environnements numériques sur mesure",
          description:
            "Application mobile dédiée, plateforme web et tableaux de bord pour patients et professionnels de santé",
        },
        {
          title: "Gestion des plans de soins",
          description:
            "Plans de soins structurés couvrant l'observance du traitement médicamenteux, les objectifs d'activité et la planification des suivis",
        },
        {
          title: "Consultations à distance",
          description: "Communication audio/vidéo, chat, partage sécurisé de fichiers et consultation en ligne",
        },
      ],
    },
    digitalOutpatientClinic: {
      description:
        "La Clinique Ambulatoire Numérique transforme les visites de routine et les suivis en interactions en ligne sécurisées et pratiques. Les patients se connectent avec leurs médecins de n'importe où, tandis que les cliniciens gèrent les rendez-vous, les dossiers et les plans de soins sur une seule plateforme.",
      features: [
        {
          title: "Consultations à distance",
          description: "Chat, vidéo et messagerie sécurisée pour communication directe patient-médecin.",
        },
        {
          title: "Planification et gestion",
          description: "Calendrier intégré pour réservations, rappels et visites de suivi.",
        },
        {
          title: "Données de santé intégrées",
          description: "Rassemble dossiers de santé, questionnaires et fichiers médicaux en un seul endroit.",
        },
        {
          title: "Environnements personnalisables",
          description:
            "Flux de travail flexibles adaptés à différentes spécialités (cardiologie, endocrinologie, dermatologie).",
        },
        {
          title: "e-Prescriptions et gestion des médicaments",
          description: "Permet aux médecins d'émettre des prescriptions numériquement.",
        },
        { title: "Support facturation", description: "Module optionnel pour gérer les paiements des patients." },
      ],
    },
    emergencyPanicButton: {
      description:
        "Accès immédiat à l'aide dans les situations urgentes. D'une simple pression, les patients peuvent alerter les soignants, cliniciens ou services d'urgence, assurant une réponse rapide quand c'est le plus important.",
      features: [
        { title: "Alerte en un clic", description: "Appel instantané à l'aide via bouton panique dédié." },
        {
          title: "Localisation en temps réel",
          description: "Suivi GPS pour guider les soignants ou secours d'urgence vers la position de l'utilisateur.",
        },
        {
          title: "Géo-zones et notifications",
          description: "Zones de sécurité configurables; alertes envoyées si le porteur sort des limites prédéfinies.",
        },
        {
          title: "Détection de chute",
          description:
            "Détection automatique des chutes et transmission d'alerte, même si l'utilisateur ne peut pas appuyer sur le bouton.",
        },
        {
          title: "Communication intégrée",
          description: "Connexion vocale ou vidéo directe avec cliniciens, centres d'appels ou membres de la famille.",
        },
        {
          title: "Parcours d'escalade personnalisés",
          description:
            "Flux de travail configurables définissant qui est notifié en premier (famille, soignant, équipe d'urgence).",
        },
      ],
    },
    mentalHealthSupport: {
      description:
        "Services numériques accessibles qui complètent les soins cliniques, permettant une évaluation continue, des interventions structurées et un meilleur engagement des patients.",
      features: [
        {
          title: "Outils d'évaluation clinique",
          description: "Questionnaires standardisés pour la dépression, l'anxiété et le suivi de l'humeur.",
        },
        {
          title: "Conseil à distance",
          description: "Sessions de chat ou vidéo sécurisées avec psychologues, psychiatres ou coachs certifiés.",
        },
        {
          title: "Ressources éducatives",
          description:
            "Ressources scientifiquement validées et contenu psychoéducatif pour soutenir l'adhésion et l'autogestion.",
        },
        {
          title: "Gestion des risques",
          description:
            "Alertes configurables pour situations de crise, assurant une escalade rapide vers cliniciens ou soignants.",
        },
        {
          title: "Planification du traitement",
          description:
            "Outils pour les cliniciens pour définir des objectifs thérapeutiques, assigner des exercices numériques et surveiller l'adhésion.",
        },
        {
          title: "Suivi des progrès",
          description:
            "Surveillance longitudinale de la progression des symptômes et de la réponse au traitement via des tableaux de bord structurés.",
        },
      ],
    },
    pregnancyMonitoring: {
      description:
        "Solutions de santé numériques qui accompagnent les mères à chaque étape de la grossesse, combinant surveillance, éducation et accès aux experts pour des parcours plus sûrs et confiants.",
      features: [
        {
          title: "Appareils connectés et wearables",
          description:
            "Suivi des signes vitaux (pression artérielle, fréquence cardiaque, glycémie, poids) et du bien-être fœtal avec des appareils de qualité médicale.",
        },
        {
          title: "Ressources éducatives",
          description:
            "Accès à du contenu fondé sur des preuves, des conseils et des directives adaptés à chaque étape de la grossesse.",
        },
        {
          title: "Connexion avec des experts",
          description:
            "Communication directe avec gynécologues, sages-femmes ou autres spécialistes pour rassurer et guider en temps voulu.",
        },
        {
          title: "Plan de soins & rappels",
          description:
            "Calendriers personnalisés pour contrôles, tests, nutrition, exercice et adhésion aux médicaments.",
        },
        {
          title: "Journal numérique",
          description:
            "Les mères peuvent enregistrer les symptômes quotidiens, les humeurs et les habitudes de vie pour des informations de soins plus complètes.",
        },
      ],
    },
    marineTelemedicine: {
      description:
        "Les soins de santé en mer sont difficiles en raison de la distance, des ressources limitées et de la connectivité intermittente. La télémédecine maritime comble cette lacune en équipant les navires d'outils pour les soins de première ligne",
      features: [
        {
          title: "Soins initiés par l'équipage",
          description:
            "Les officiers désignés agissent comme premiers intervenants, soutenus par des spécialistes à distance.",
        },
        {
          title: "Conception hors ligne prioritaire",
          description:
            "Les données médicales sont enregistrées pendant l'incident et synchronisées avec les experts une fois l'accès Internet rétabli.",
        },
        {
          title: "Dispositifs médicaux connectés",
          description:
            "Outils de diagnostic à bord (ECG, oxymètre, tensiomètres) capturent les signes vitaux pour examen à distance.",
        },
        {
          title: "Échange d'images et fichiers",
          description:
            "Photos, scans ou autres documents peuvent être partagés avec les spécialistes pour soutenir une évaluation précise.",
        },
        {
          title: "Consultations à distance",
          description:
            "Vidéo ou messagerie avec médecins à terre pour triage, soins aigus ou gestion de conditions chroniques.",
        },
        {
          title: "Intégration logistique",
          description:
            "Coordination avec ports, cliniques et services d'évacuation lorsque des soins sur place sont requis.",
        },
      ],
    },
    behaviouralChangeSolutions: {
      description:
        "Changer les habitudes est au cœur de la prévention. Les solutions de changement comportemental combinent des outils numériques avec des méthodes fondées sur des preuves pour motiver des modes de vie plus sains et soutenir l'observance à long terme.",
      features: [
        {
          title: "Programmes personnalisés",
          description:
            "Plans sur mesure pour la nutrition, l'activité et le changement de mode de vie basés sur les besoins individuels.",
        },
        {
          title: "Définition d'objectifs et rappels",
          description:
            "Objectifs structurés avec notifications intelligentes qui maintiennent les utilisateurs engagés et sur la bonne voie.",
        },
        {
          title: "Surveillance quotidienne",
          description: "Suivi quotidien des pas, de l'activité, du poids et d'autres indicateurs de bien-être clés.",
        },
        {
          title: "Retour motivationnel",
          description: "Encouragement et informations en temps réel qui soutiennent les progrès à long terme.",
        },
        {
          title: "Contenu éducatif",
          description: "Ressources fondées sur des preuves qui expliquent la science derrière les choix sains.",
        },
        {
          title: "Visualisation des progrès",
          description:
            "Graphiques et tableaux de bord clairs qui mettent en évidence les jalons et l'amélioration globale.",
        },
      ],
    },
    corporateWellbeing: {
      description:
        "Des lieux de travail sains créent des entreprises plus fortes. Les programmes de bien-être en entreprise améliorent la santé des employés, réduisent l'absentéisme et construisent une culture d'engagement et de résilience.",
      features: [
        {
          title: "Plateformes de marque",
          description: "Plateformes de marque employeur qui promeuvent le bien-être dans toute la main-d'œuvre.",
        },
        {
          title: "Programmes de santé",
          description: "Programmes soutenant la gestion du stress, l'activité physique et la santé mentale.",
        },
        {
          title: "Outils d'engagement",
          description: "Outils numériques qui encouragent la participation par des rappels et la gamification.",
        },
        {
          title: "Ressources de style de vie",
          description: "Accès à des ressources pour une nutrition et des choix de mode de vie plus sains.",
        },
        {
          title: "Analytique de la main-d'œuvre",
          description:
            "Analyses qui aident les RH à suivre la participation, les résultats et le retour sur investissement.",
        },
        {
          title: "Intégration des politiques",
          description: "Alignement avec les politiques de santé et de sécurité au travail déjà en place.",
        },
      ],
    },
    scientificWellness: {
      description:
        "La prévention entre dans l'ère de la précision. Le bien-être scientifique intègre données génétiques, biomarqueurs et métriques de santé numériques pour créer des stratégies de bien-être individualisées ancrées dans la science.",
      features: [
        {
          title: "Profilage complet",
          description:
            "Collecte de données génétiques, de biomarqueurs et de style de vie pour construire le profil de santé de chaque individu.",
        },
        {
          title: "Planification personnalisée",
          description: "Stratégies de bien-être fondées sur des preuves scientifiques et des objectifs mesurables.",
        },
        {
          title: "Surveillance continue",
          description:
            "Suivi en temps réel de signaux biologiques tels que le stress, la variabilité de la fréquence cardiaque et les marqueurs métaboliques.",
        },
        {
          title: "Recommandations adaptatives",
          description:
            "Boucles de rétroaction qui ajustent les recommandations à mesure que de nouvelles données sont collectées.",
        },
        {
          title: "Ressources scientifiques",
          description: "Matériel éducatif qui explique la science derrière chaque recommandation.",
        },
        {
          title: "Aperçus",
          description:
            "Tableaux de bord visuels qui montrent les progrès et mettent en évidence les tendances de santé émergentes.",
        },
      ],
    },
    ehealthWellnessTourism: {
      description:
        "Le tourisme et la santé se croisent de nouvelles façons. Le tourisme eSanté et bien-être combine bilans préventifs et programmes de bien-être avec des expériences de voyage, offrant aux visiteurs un suivi numérique à long terme après leur séjour.",
      features: [
        {
          title: "Évaluations préventives",
          description: "Évaluations de santé préventive sur place intégrées dans les forfaits de voyage bien-être.",
        },
        {
          title: "Nutrition personnalisée",
          description:
            "Hôtels et centres de villégiature qui adaptent les options de repas au profil de santé et aux objectifs de bien-être du visiteur.",
        },
        {
          title: "Plans de bien-être",
          description:
            "Plans de bien-être personnalisés qui combinent des conseils médicaux avec un accompagnement sur le mode de vie.",
        },
        {
          title: "Intégration culturelle",
          description:
            "Programmes qui fusionnent culture locale, nature et pratiques de bien-être pour des expériences holistiques.",
        },
        {
          title: "Continuité des soins",
          description:
            "Intégration de données qui assure la continuité des soins entre les services touristiques et les prestataires de santé.",
        },
        {
          title: "Tableaux de bord bien-être",
          description:
            "Dossiers numériques et tableaux de bord qui aident les visiteurs à suivre leur parcours bien-être au fil du temps.",
        },
      ],
    },
    insurtech: {
      description:
        "La transformation numérique remodèle l'assurance, déplaçant l'accent de la gestion des sinistres vers la santé proactive et la valeur client à long terme.",
      features: [
        {
          title: "Téléconsultations",
          description:
            "Séances médicales en ligne incluses dans les forfaits d'assurance, améliorant l'accès et réduisant les coûts.",
        },
        {
          title: "Télé-souscription",
          description:
            "Évaluation de santé à distance pour une stratification des risques et une approbation des polices d'assurance plus rapides et plus précises.",
        },
        {
          title: "Soins personnalisés",
          description:
            "Accent sur la prévention, le diagnostic précoce et la surveillance à distance pour réduire les sinistres et améliorer les résultats.",
        },
        {
          title: "Expérience client",
          description:
            "Applications mobiles de marque ou en marque blanche qui améliorent l'accessibilité, la fidélité et la satisfaction des utilisateurs.",
        },
        {
          title: "Gestion des risques basée sur les données",
          description:
            "Analyses avancées qui améliorent la précision de la souscription, prévoient les coûts et soutiennent une conception de produits plus intelligente.",
        },
        {
          title: "Nouveaux modèles commerciaux",
          description:
            "Permettre aux assureurs de concevoir des produits préventifs et basés sur la valeur qui élargissent l'offre de services et la compétitivité.",
        },
      ],
    },
    digitalTherapeuticsPharma: {
      description:
        "Lorsque le médicament sort de la boîte, il devient numérique. Nous fournissons des interventions logicielles et des applications compagnes qui étendent le traitement, améliorent l'observance et génèrent des preuves du monde réel.",
      features: [
        {
          title: "Applications compagnes pour médicaments",
          description:
            "Applications de marque ou en marque blanche qui guident les patients dans l'utilisation des médicaments, fournissent des rappels et offrent du contenu éducatif personnalisé.",
        },
        {
          title: "Thérapeutiques numériques fondées sur des preuves",
          description:
            "Applications et interventions validées cliniquement traitant des conditions spécifiques telles que le diabète, l'insomnie ou la dépression.",
        },
        {
          title: "Support d'observance médicamenteuse",
          description:
            "Rappels de pilules, journaux numériques et dispositifs connectés qui renforcent la conformité au traitement.",
        },
        {
          title: "Support d'essai clinique (modules eCRF)",
          description:
            "Formulaires de rapport de cas électroniques avec questionnaires intégrés, suivi des symptômes et surveillance numérique, conçus pour simplifier la collecte de données d'essai.",
        },
        {
          title: "Analytique et rapports",
          description:
            "Analyse automatisée des résultats rapportés par les patients et des données cliniques, générant des rapports prêts pour la réglementation.",
        },
        {
          title: "Engagement des patients",
          description:
            "Fonctionnalités interactives qui motivent les patients par le feedback, le suivi des progrès et la communication avec les coordinateurs d'essai ou les équipes de soins.",
        },
      ],
    },
    digitalAnimalHealth: {
      description:
        "Des animaux de compagnie à la maison aux troupeaux dans les champs, les outils numériques transforment les soins vétérinaires. Nos solutions apportent surveillance, dossiers et conseils d'experts dans un environnement connecté.",
      features: [
        {
          title: "Consultations télé-vétérinaires",
          description:
            "Réservez et gérez des rendez-vous vétérinaires en ligne, pour les contrôles, le suivi et les situations urgentes.",
        },
        {
          title: "Dossiers de santé numériques",
          description:
            "Profils d'animaux complets incluant calendriers de vaccination, traitements, nutrition et diagnostics.",
        },
        {
          title: "Conseils à distance pour les soins",
          description:
            "Instructions numériques et plans de suivi pour la nutrition, la récupération et les routines préventives après les visites vétérinaires.",
        },
        {
          title: "Surveillance au niveau de la population",
          description:
            "Analyses pour troupeaux de bétail, refuges et programmes d'élevage, soutenant la prévention des maladies et la gestion du bien-être.",
        },
        {
          title: "Intégration avec la pharma vétérinaire",
          description:
            "Applications compagnes liées aux traitements pour soutenir l'observance et suivre les résultats.",
        },
        {
          title: "Analyse de données et rapports",
          description:
            "Systèmes d'alerte précoce pour les épidémies, suivi des performances et stratégies de soins optimisées.",
        },
      ],
    },
    ecoHealthAnalytics: {
      description:
        "Les conditions environnementales façonnent la santé humaine. L'analyse Éco-Santé révèle ces liens en combinant informations environnementales et cliniques pour dévoiler des modèles, prédire les risques et guider des décisions plus intelligentes pour les villes et l'industrie.",
      features: [
        {
          title: "Jeux de données publiques",
          description:
            "Importation et traitement de jeux de données provenant de bases de données d'indicateurs environnementaux établies.",
        },
        {
          title: "Flux de données environnementales",
          description:
            "Importation de flux de données depuis des capteurs environnementaux mesurant la qualité de l'air, les polluants ou les indicateurs climatiques depuis des réseaux de capteurs et des API ouvertes pour enrichir les analyses de santé.",
        },
        {
          title: "Corrélation santé-environnement",
          description:
            "Analyse de jeux de données combinés pour identifier les modèles, tendances et facteurs de risque qui lient les expositions environnementales aux résultats de santé",
        },
        {
          title: "Analyse de tendances et alertes",
          description:
            "Surveillance des niveaux d'exposition à long terme et alertes automatiques pour événements à haut risque tels que canicules ou pics de pollution.",
        },
        {
          title: "Support décisionnel pour villes et industrie",
          description:
            "Fournir des informations fondées sur des preuves pour guider la planification urbaine, la santé au travail et les stratégies de durabilité des entreprises.",
        },
        {
          title: "Visualisation et tableaux de bord",
          description:
            "Cartes et tableaux de bord interactifs qui affichent les indicateurs environnementaux aux côtés des résultats de santé pour une interprétation plus facile.",
        },
      ],
    },
    aiDecisionSupport: {
      description:
        "Assistance clinique intelligente alimentée par l'IA avancée pour améliorer la prise de décision, rationaliser les flux de travail et améliorer les résultats pour les patients.",
      features: [
        {
          title: "Révision de dossier par IA",
          description:
            "Récupère et résume les éléments pertinents du profil patient pour que les médecins puissent scanner rapidement examens, historique, médicaments et notes.",
        },
        {
          title: "Signes vitaux sans contact",
          description:
            "Mesurez la fréquence cardiaque et les indicateurs de bien-être via la caméra du téléphone en utilisant la technologie rPPG avancée. En un seul scan court, les patients obtiennent des informations aussi facilement qu'en prenant un selfie.",
        },
        {
          title: "Évaluation et prédiction des risques",
          description:
            "Notation basée sur des questionnaires et modèles IA, associés à des conseils de style de vie personnalisés.",
        },
        {
          title: "Vérificateur de symptômes",
          description:
            "Symptômes entrés par le patient évalués par l'IA avec actions suggérées et conseils sur quand consulter.",
        },
        {
          title: "Support de décision clinique",
          description:
            "Modèles qui signalent le risque de détérioration, proposent les prochaines étapes et soutiennent les interventions préventives et personnalisées.",
        },
        {
          title: "Intelligence d'affaires",
          description:
            "Tableaux de bord qui analysent l'activité dans les établissements pour optimiser la dotation, la planification des sorties et le suivi tout en suivant les réadmissions et les coûts.",
        },
      ],
    },
    drgDecisionSupport: {
      description:
        "Les Groupes Homogènes de Malades (GHM) sont plus qu'un outil de remboursement. Utilisés efficacement, ils deviennent un mécanisme de support décisionnel qui améliore le contrôle des coûts, la transparence et la confiance entre assureurs, prestataires et patients, tout en soutenant les hôpitaux dans le codage précis et l'audit.",
      features: [
        {
          title: "Optimisation des coûts",
          description:
            "Le coût standardisé des cas médicaux par diagnostic et gravité clinique réduit la variabilité et rend les dépenses de santé plus prévisibles.",
        },
        {
          title: "Tarification transparente",
          description:
            "Soutient les assureurs, prestataires et patients avec des modèles de coûts fiables et comparables qui renforcent la confiance et la compétitivité.",
        },
        {
          title: "Évaluation des risques pour l'assurance",
          description:
            "Améliore l'estimation des risques pour les régimes de santé de groupe et individuels, aidant à concevoir des produits d'assurance durables.",
        },
        {
          title: "Support de codage hospitalier",
          description:
            "Aide les cliniciens et codeurs avec l'enregistrement correct et cohérent des cas basé sur les classifications CIM et GPC.",
        },
        {
          title: "Audit et contrôle qualité",
          description:
            "Les mécanismes d'audit automatisés identifient les faiblesses dans le codage des dossiers médicaux et soutiennent l'action corrective précoce.",
        },
        {
          title: "Améliorations ciblées",
          description:
            "Les résultats d'audit guident les interventions telles que la formation du personnel, les mises à jour des directives opérationnelles et les affinements de codage.",
        },
      ],
    },
    digitalHealthConsulting: {
      description:
        "Conseil stratégique et accompagnement expert pour les organisations de santé naviguant la transformation numérique et l'innovation.",
      features: [
        {
          title: "Stratégie de santé numérique",
          description:
            "Élaboration de feuilles de route pour hôpitaux, municipalités et assureurs pour adopter et faire évoluer les solutions numériques.",
        },
        {
          title: "Interopérabilité et intégration",
          description:
            "Conseils sur les normes telles que HL7 FHIR, DICOM et openEHR pour garantir que les systèmes communiquent de manière sécurisée et efficace.",
        },
        {
          title: "Refonte des processus",
          description:
            "Support pour restructurer les flux de travail cliniques et administratifs afin de les aligner avec les objectifs de transformation numérique.",
        },
        {
          title: "Conformité réglementaire",
          description:
            "Expertise sur MDR, GDPR et cadres nationaux pour garantir que les projets respectent les exigences légales et éthiques.",
        },
        {
          title: "Renforcement des capacités",
          description: "Programmes de formation et de support pour cliniciens, administrateurs et équipes techniques.",
        },
        {
          title: "Évaluation et KPI",
          description:
            "Conception de cadres de surveillance avec indicateurs mesurables pour la performance, l'efficacité et l'impact.",
        },
      ],
    },
  },
  investorRelations: {
    title: "Relations Investisseurs",
    description:
      "VIDAVO, fondée en 2002, dont le siège est à Thessalonique, en Grèce, et possède des bureaux à Athènes. Elle est cotée sur le marché alternatif (ΕΝ.Α. Growth) d'Euronext Athens (OASIS: BINTA).",
    stockExchange: {
      title: "Publications boursières",
      ticker: "Symbole OASIS",
      description: "Un aperçu détaillé des informations boursières passées et actuelles, identifiées par le symbole",
      issuersCorner: "Coin des émetteurs",
      stockInfo: "Informations boursières",
    },
    keyMetrics: {
      revenueGrowth: {
        label: "Croissance des revenus",
        value: "45%",
        description: "Croissance annuelle",
      },
      marketPenetration: {
        label: "Pénétration du marché",
        value: "15+",
        description: "Pays desservis",
      },
      healthcarePartners: {
        label: "Partenaires de santé",
        value: "250+",
        description: "Partenariats actifs",
      },
      patientLives: {
        label: "Vies de patients impactées",
        value: "1M+",
        description: "Via nos plateformes",
      },
    },
    documents: {
      title: "Documents pour les investisseurs",
      download: "Télécharger",
      categories: {
        financial: "Rapports annuels",
        governance: "Rapports du 1er semestre",
        presentations: "Bilan",
        regulatory: "Annonces",
        assemblies: "Assemblées générales",
      },
      names: {
        annualReport: "rapport annuel",
        firstSemester: "1er semestre",
        balanceSheet: "Bilan",
        balanceSheetFirstSemester: "Bilan (1er semestre)",
        announcement: "Annonce",
        generalMeeting: "AG",
        corporatePresentation: "Présentation annuelle de l'entreprise",
      },
    },
    contact: {
      title: "Contact Relations Investisseurs",
      description:
        "Pour les opportunités d'investissement, les informations financières ou les demandes des investisseurs, veuillez contacter notre équipe",
      sendEmail: "Envoyer un e-mail",
    },
  },

  careers: {
    title: "Carrières chez VIDAVO",
    subtitle:
      "Rejoignez notre mission de transformer les soins de santé grâce à une technologie innovante. Construisez votre carrière tout en ayant un impact significatif sur les résultats de santé mondiaux.",
    whyWorkAtVidavo: {
      title: "Pourquoi travailler chez VIDAVO",
      description:
        "Chez VIDAVO, vous ferez partie d'une équipe dynamique qui révolutionne la prestation de soins de santé. Nous offrons un environnement collaboratif où l'innovation prospère et où chaque membre de l'équipe contribue à améliorer des vies grâce à la technologie.",
      culture: {
        title: "Notre Culture",
        description:
          "Nous favorisons une culture d'innovation, de collaboration et d'apprentissage continu. Notre équipe est passionnée par la technologie de la santé et s'engage à avoir un impact positif sur les résultats des patients dans le monde entier.",
        values: {
          innovation: "Environnement axé sur l'innovation",
          learning: "Opportunités d'apprentissage continu",
          collaboration: "Culture d'équipe collaborative",
          impact: "Impact significatif sur la santé",
        },
      },
    },
    noOpenPositions: {
      description:
        "Nous sommes toujours ravis de rencontrer des personnes qui partagent notre philosophie et qui pourraient se voir grandir avec nous. Pour les opportunités d'emploi actuelles, veuillez visiter notre page",
      linkedIn: "LinkedIn",
      descriptionEnd:
        ". Si vous pensez que votre état d'esprit et vos compétences correspondent à notre travail, nous serions ravis de vous entendre.",
      sendEmail: "Envoyer un e-mail",
    },
  },
  personalData: {
    badge: "PROTECTION DES DONNÉES GDPR",
    title: "Politique de confidentialité et protection des données",
    description:
      "Nous vous remercions de visiter le site web de VIDAVO et vous assurons que la protection de vos données personnelles est notre priorité absolue.",
    sections: {
      usefulDefinitions: "Définitions utiles",
      dataController: "Responsable du traitement des données",
      whatDataWeProcess: "Quelles données nous traitons",
      informationRegardingCookies: "Informations concernant les cookies",
      yourRights: "Vos droits et comment les exercer",
      periodOfStorage: "Période de conservation des données",
      informationSecurityPolicy: "Politique de sécurité de l'information",
      purposesAndLegalBasis: "Finalités et base juridique du traitement de vos données",
      thirdPartyLinks: "Liens vers des sites web de tiers",
      revisions: "Révisions",
      antiBriberyPolicy: "Politique anti-corruption",
    },
    usefulDefinitionsContent: {
      intro: "Pour votre meilleure information, nous utilisons les termes suivants qui sont définis comme suit :",
      personalData:
        "a) \"Données personnelles\" : sont des informations relatives à une personne physique. Les données sont considérées comme personnelles si la personne qu'elles concernent peut être identifiée, directement ou indirectement (c'est-à-dire soit en mentionnant le nom, le numéro d'identification, l'adresse du domicile et d'autres coordonnées (numéro de téléphone, courriels), l'adresse IP de l'appareil utilisé pour se connecter en ligne, l'âge, le sexe, les caractéristiques externes, la situation familiale, le niveau d'éducation, la profession, les intérêts, etc.). La personne physique à laquelle les données personnelles se rapportent est appelée \"personne concernée\".",
      sensitiveData:
        'b) "Catégories particulières de données personnelles" (ou "données sensibles") : sont des données relatives à la sphère intime de l\'individu (par exemple, santé, convictions religieuses, opinions politiques, activités syndicales, origine raciale, vie sexuelle).',
      dataProcessing:
        "c) \"Traitement des données\" : est toute activité impliquant des données personnelles, quels que soient les moyens appliqués (c'est-à-dire automatisés ou manuels) tels que la collecte, l'enregistrement, l'organisation, la structuration, la conservation, l'adaptation ou la modification, l'extraction, la recherche d'informations, l'utilisation, la divulgation par transmission, la diffusion ou toute autre forme de mise à disposition, l'association ou la combinaison, la limitation, l'effacement ou la destruction.",
      legislation:
        'd) "Législation" : la législation grecque et européenne sur la protection des personnes physiques à l\'égard du traitement des données à caractère personnel, y compris le Règlement général sur la protection des données 2016/79 (GDPR).',
      dataLogs:
        'e) "Journaux de données" : fichiers électroniques concernant les mouvements sur le site web qui sont enregistrés sur notre serveur.',
      cookies:
        'f) "Cookies" : Petits fichiers de données sous forme de texte qui sont stockés sur votre appareil électronique (ordinateur, mobile, tablette) lorsque vous visitez le site Web et qui fournissent',
      specificInformation: "des informations spécifiques",
      cookiesEnd: "concernant vos mouvements sur le site web.",
    },
    dataControllerContent: {
      paragraph1:
        "Responsable du traitement des données : Le responsable du traitement des données conformément à l'art. 4 para. 7 du Règlement général sur la protection des données (GDPR) est VIDAVO AE, BALKAN CENTER, 10 km Thessaloniki-N. Moudania, 57001 Thermi, vidavo@vidavo.eu.",
      paragraph2:
        "Vous pouvez contacter le responsable du traitement des données à l'adresse suivante dpo@vidavo.eu ou à l'adresse postale avec la mention \"à l'attention du responsable du traitement des données\".",
    },
    whatDataWeProcessContent: {
      sectionA: "A) Données enregistrées automatiquement sur notre serveur",
      dataLogs: "(1) Journaux de données",
      dataLogsIntro:
        "Lorsque vous entrez sur notre site Web, nous collectons les données personnelles (journaux de données) qui sont transmises à notre serveur par votre navigateur et spécifiquement :",
      dataLogsList: [
        "Adresse IP",
        "Date et heure de votre entrée",
        "Différence horaire avec le temps moyen de Greenwich - GMT",
        "Contenu de la demande (page spécifique)",
        "Code d'état HTTP",
        "Toute quantité de données transmises",
        "Page Web d'où provient la demande",
        "Navigateur",
        "Système d'exploitation",
        "Langue et édition du logiciel de navigation",
      ],
      cookiesSubtitle: "(2) Cookies",
      cookiesText:
        "En plus des données mentionnées ci-dessus, lorsque vous utilisez le site Web, des cookies sont stockés sur votre PC, c'est-à-dire de petits fichiers de données (fichiers texte) qui sont stockés sur l'appareil que vous utilisez et transmettent des données d'identification concernant votre appareil à notre serveur, c'est-à-dire qu'un numéro d'identification unique est créé. Il convient de noter qu'à l'exception des \"cookies de session\", qui sont absolument nécessaires pour votre accès et utilisation sans entrave de notre site Web, tous les autres cookies ne sont stockés sur notre serveur que si vous avez donné votre consentement et que vous les activez lorsque vous entrez sur notre site Web.",
      sectionB: "B) Données que vous saisissez",
      sectionBText:
        "Lorsque vous communiquez par e-mail, nous stockons les données que vous fournissez (votre e-mail, éventuellement votre nom et votre numéro de téléphone) afin de répondre à vos questions. Dans ce contexte, lorsque le stockage n'est plus nécessaire, nous supprimons les données en question ou nous réduisons leur traitement, dans le cas où il n'y a pas d'obligation légale de conserver les données. Vous pouvez nous demander à tout moment de cesser d'utiliser votre adresse e-mail et de vous abstenir de toute information/communication supplémentaire, en exerçant le \"droit d'opposition\" tel que prévu par la législation pertinente.",
    },
    cookiesInfoContent: {
      intro:
        "Notre site web utilise des cookies pour améliorer votre expérience de navigation, fournir des fonctionnalités essentielles et analyser l'utilisation du site. Vous trouverez ci-dessous des informations détaillées sur les cookies que nous utilisons :",
      essentialTitle: "Cookies essentiels",
      essentialText:
        "Ces cookies sont nécessaires au bon fonctionnement du site web et ne peuvent pas être désactivés. Ils sont généralement définis en réponse aux actions que vous effectuez, telles que la définition de vos préférences de confidentialité, la connexion ou le remplissage de formulaires.",
      analyticsTitle: "Cookies analytiques",
      analyticsText:
        "Ces cookies nous aident à comprendre comment les visiteurs interagissent avec notre site web en collectant et en rapportant des informations de manière anonyme. Cela nous aide à améliorer les performances et l'expérience utilisateur de notre site web.",
      tableHeaders: {
        cookieName: "Nom du cookie",
        category: "Catégorie",
        purpose: "Objectif",
        duration: "Durée",
      },
      tableData: [
        {
          name: "cookie-consent",
          category: "Essentiel",
          purpose:
            "Stocke vos préférences de consentement aux cookies pour mémoriser vos choix concernant les cookies que vous acceptez.",
          duration: "1 an",
        },
        {
          name: "session-id",
          category: "Essentiel",
          purpose:
            "Maintient l'état de votre session lors de la navigation sur le site web pour garantir une fonctionnalité appropriée.",
          duration: "Session uniquement",
        },
        {
          name: "_ga",
          category: "Analytique",
          purpose:
            "Cookie Google Analytics qui distingue les utilisateurs uniques et fournit des informations sur les modèles d'utilisation du site web.",
          duration: "2 ans",
        },
        {
          name: "_ga_*",
          category: "Analytique",
          purpose:
            "Cookie Google Analytics 4 qui collecte des informations sur la façon dont vous interagissez avec notre site web.",
          duration: "2 ans",
        },
      ],
      managingTitle: "Gestion de vos préférences en matière de cookies",
      managingText:
        'Vous pouvez gérer vos préférences en matière de cookies à tout moment en cliquant sur le lien "Paramètres des cookies" dans le pied de page de notre site web ou en utilisant les paramètres de votre navigateur pour bloquer ou supprimer les cookies. Veuillez noter que la désactivation des cookies essentiels peut affecter le fonctionnement de notre site web.',
    },
    yourRightsContent: {
      intro: "Vous pouvez à tout moment exercer les droits suivants qui sont prévus par le GDPR :",
      rights: [
        "Droit de savoir quelles données personnelles vous concernant sont traitées via notre plateforme et de quelle manière, droit d'obtenir des copies de ces données, ainsi que toute autre information concernant le traitement (\"droit à l'information et à l'accès\").",
        "Droit de rectification, c'est-à-dire droit de demander la correction et/ou la complétion de données incorrectes ou incomplètes, par exemple si vous changez votre adresse e-mail, vous demandez que nous la remplacions par la nouvelle adresse.",
        "Droit de demander l'effacement des données ('droit à l'oubli') et/ou droit à la limitation du traitement, s'il n'est plus nécessaire ou s'il n'est pas effectué conformément à la loi ou si la suppression est obligatoire par la loi.",
        "Droit de limiter le traitement, c'est-à-dire droit de demander que le traitement soit limité pendant la durée de votre demande de correction ou de suppression.",
        "Droit à la portabilité des données, c'est-à-dire le droit de demander à recevoir vos données dans un format électronique lisible et de demander la transmission de ces données par nous à des tiers que vous indiquerez.",
        "Droit de vous opposer au traitement de vos données personnelles.",
      ],
      contactTitle: "Informations de contact",
      contactText1:
        "Afin d'exercer vos droits ci-dessus et pour toute communication concernant vos données personnelles, vous pouvez communiquer par e-mail à dpo@vidavo.eu, à l'attention de Paraskevi Katsouli ou par téléphone au +302310474762.",
      contactText2:
        "De plus, si vous estimez que vos données personnelles sont d'une manière ou d'une autre compromises, vous avez le droit de déposer une plainte auprès de l'Autorité de protection des données (1-3 Kifissias Av., 11523 Athènes, 210 6475600, contact@dpa.gr).",
    },
    purposesAndLegalBasisContent: {
      paragraph1:
        "Le but de l'enregistrement de l'adresse IP et du traitement des données des Journaux de Fichiers et du Cookie Obligatoire est le fonctionnement de notre Site Web ainsi que la résolution de problèmes techniques éventuels et la protection de notre Site Web contre une utilisation malveillante ou illégale potentielle (par exemple via l'enregistrement des adresses IP). La base juridique du traitement ci-dessus est notre intérêt légitime à protéger la sécurité et l'intégrité de notre Site Web.",
      paragraph2:
        "Le traitement des données des Cookies Volontaires vise à gérer, analyser et mettre à jour le Site Web par l'extraction et l'analyse de données statistiques qui se réfèrent au nombre de nos visiteurs, au nombre de fois que chaque visiteur nous visite, à leur origine géographique, à la langue qu'ils préfèrent voir sur notre Site Web, aux pages qu'ils visitent le plus souvent en vue d'évaluer le comportement de l'utilisateur (par exemple à des fins de publicité comportementale). Le traitement en question est basé sur votre consentement, c'est-à-dire l'activation de chaque cookie lorsque vous entrez sur notre Site Web, que vous pouvez retirer à tout moment de la même manière, en désactivant les cookies que vous souhaitez.",
    },
    thirdPartyLinksContent:
      "Le site Web fait référence à des sites Web de tiers qui peuvent effectuer un traitement supplémentaire des données de leurs visiteurs/utilisateurs, utiliser différents cookies, etc. Vidavo n'assume aucune responsabilité concernant ces sites Web et pour toute question pertinente, vous devrez contacter les propriétaires concernés.",
    revisionsContent:
      "Avant toute modification potentielle du traitement des données personnelles via le site Web, nous modifierons la présente Politique en conséquence et l'afficherons afin que vous puissiez recevoir les informations pertinentes et être en mesure d'exercer vos droits de manière efficace.",
    periodOfStorageContent: {
      ipAddress:
        "L'adresse IP de votre appareil (pc, mobile ou tablette) qui est stockée automatiquement sur notre serveur lorsque vous entrez sur notre site Web est conservée pendant trois mois à partir du moment où vous entrez sur le site Web et est supprimée automatiquement par la suite.",
      sessionCookies:
        "Les Cookies de session sont supprimés lorsque vous vous déconnectez ou fermez votre navigateur. En ce qui concerne les cookies « optionnels », ils sont stockés pour la période mentionnée dans le tableau ci-dessus.",
      emailData:
        "Les données que vous nous fournissez afin de nous contacter par e-mail (votre e-mail, éventuellement votre nom et numéro de téléphone), sont conservées aussi longtemps que nécessaire, afin que nous puissions répondre à vos questions et si le stockage n'est plus nécessaire, nous supprimons les données ou réduisons leur traitement, à condition que nous ne soyons pas obligés de conserver les données par la loi.",
      claimsData:
        "Dans le cas où une réclamation est déposée (en justice ou hors justice), les données seront conservées jusqu'à la résolution finale et sans appel des réclamations ou jusqu'à ce qu'elles soient prescrites.",
    },
    informationSecurityPolicyContent: {
      intro:
        "VIDAVO S.A., répondant aux exigences de la réalité commerciale moderne et visant à la protection des informations qu'elle gère, visant toujours le service ininterrompu et exemplaire à ses Clients par le maintien de la confidentialité, de la disponibilité et de l'intégrité des informations, a décidé de concevoir et d'installer un Système de Management de la Sécurité de l'Information conformément aux exigences de la Norme Internationale ISO 27001:2022.",
      coversTitle: "Le Système de Management de la Sécurité de l'Information de l'entreprise couvre :",
      coversList: [
        "Conception, développement et production de logiciels pour la réception, le traitement et la transmission de signaux et d'informations médicales",
        "Formation à l'utilisation de logiciels pour la réception, le traitement et la transmission de signaux et d'informations médicales",
        "Support technique de logiciels pour la réception, le traitement et la transmission de signaux et d'informations médicales",
        "Distribution de dispositifs médicaux pour la surveillance et la mesure des paramètres physiologiques, et leurs consommables",
      ],
      objectivesTitle: "Objectifs Principaux :",
      objectivesList: [
        "Assurer la confidentialité, l'intégrité et la disponibilité des informations gérées, y compris les données personnelles",
        "Assurer le bon fonctionnement des systèmes d'information",
        "La réponse rapide aux incidents qui peuvent mettre en danger ses opérations commerciales",
        "Respecter les exigences législatives et réglementaires",
        "L'amélioration continue du niveau de sécurité de l'information",
      ],
      managingDirector: "Directrice Générale",
      name: "Markella Psymarnou",
      date: "Thessalonique, 13/09/2024",
    },
    antiBriberyPolicyContent: {
      policySummary: {
        title: "Résumé de la politique",
        intro:
          "VIDAVO S.A. s'engage à mener ses affaires conformément aux normes éthiques les plus élevées et interdit toutes les formes de corruption. Cette Politique Anti-Corruption interdit la corruption de fonctionnaires ainsi que la corruption du secteur privé, y compris l'offre, la promesse, l'autorisation ou la fourniture de toute chose de valeur à tout client, partenaire commercial, fournisseur ou autre tiers afin d'induire ou de récompenser une performance incorrecte d'une activité liée à nos affaires. La violation de cette Politique pourrait entraîner des mesures disciplinaires, y compris, mais sans s'y limiter, le licenciement. Il est crucial que vous compreniez et appréciiez non seulement l'importance de cette Politique, mais que vous vous y conformiez dans votre travail quotidien. Si vous avez des questions concernant cette Politique ou les lois anti-corruption applicables en général, veuillez contacter le Responsable du Système Anti-Corruption à compliance@vidavo.eu.",
        conjunction:
          "Conjointement avec cette Politique, veuillez vous référer aux Documents de Procédure Anti-Corruption pour des informations et détails supplémentaires.",
      },
      purposeAndObjectives: {
        title: "Objectif et buts de la politique",
        content:
          "Cette Politique vise à décrire les risques de l'entreprise liés à la corruption, à mettre en évidence vos responsabilités en vertu des lois anti-corruption pertinentes et des politiques de l'entreprise, et à vous fournir les outils et le soutien nécessaires pour identifier et combattre ces risques anti-corruption.",
      },
      risksAndConsequences: {
        title: "Risques et/ou conséquences du non-respect",
        content:
          "La violation des lois anti-corruption pertinentes peut entraîner de graves sanctions civiles et pénales et nuire à la réputation de notre entreprise. Les employés de l'entreprise qui violent ces lois peuvent également faire face à de graves sanctions civiles et pénales, y compris des peines de prison. Une violation de cette Politique pourrait entraîner des mesures disciplinaires, y compris, mais sans s'y limiter, le licenciement.",
      },
      scopeAndRange: {
        title: "Portée et champ d'application",
        content:
          "L'entreprise attend de tous les employés, dirigeants, administrateurs et tiers travaillant en son nom qu'ils s'abstiennent de toute forme de corruption, quelle que soit leur nationalité, résidence ou localisation. En plus de cette interdiction générale de la corruption, cette Politique et les Documents de Procédure établissent plusieurs exigences de politique et de procédure qui s'appliquent à tous ses employés.",
      },
      policyDetails: {
        title: "Détails de la politique",
        applicableLaws: {
          title: "4.1 Lois applicables",
          content:
            "Les employés de l'entreprise doivent se conformer à toutes les lois anti-corruption applicables. Ces lois interdisent généralement à la fois la corruption de fonctionnaires et la corruption du secteur privé.",
        },
        prohibitionOfBribery: {
          title: "4.2 Interdiction de la corruption",
          governmentBribery: {
            title: "4.2.1 Corruption gouvernementale",
            content:
              "L'entreprise et ses employés sont interdits de donner, promettre, offrir ou autoriser le paiement de toute chose de valeur à tout fonctionnaire pour obtenir ou conserver des affaires, obtenir tout autre avantage inapproprié, ou influencer indûment les actions d'un fonctionnaire. De plus, les associés de l'entreprise doivent également éviter les interactions inappropriées avec les fonctionnaires.",
          },
          commercialBribery: {
            title: "4.2.2 Corruption commerciale",
            content:
              "En plus des interdictions de corruption de fonctionnaires discutées ci-dessus, l'entreprise interdit aux employés d'offrir ou de fournir des paiements et autres avantages à des personnes et entités privées ou d'en accepter. Ces paiements constituent une corruption commerciale et sont souvent appelés « pots-de-vin ».",
          },
          facilitationPayments: {
            title: "4.2.3 Paiements de facilitation",
            content:
              "L'interdiction de corruption de l'entreprise s'applique à tous les paiements inappropriés quelle que soit leur taille ou leur objectif, y compris les paiements « de facilitation » (ou d'accélération). Les paiements de facilitation font référence à de petits paiements à des fonctionnaires pour accélérer ou faciliter des actions ou services, tels que l'obtention d'une licence, le traitement de documents gouvernementaux tels que des visas, le dédouanement, la fourniture de services téléphoniques, d'électricité ou d'eau, ou le chargement ou déchargement de marchandises. Généralement, les paiements de facilitation sont interdits par cette Politique.",
          },
        },
        provisionOfItems: {
          title: "4.3 Fourniture d'objets de valeur aux fonctionnaires",
          governmentTransactionApproval: {
            title: "4.3.1 Outil d'approbation des transactions gouvernementales",
            content:
              "Avant de fournir un objet de valeur à tout fonctionnaire ou entité gouvernementale, les employés doivent d'abord obtenir l'approbation écrite du conseiller juridique de l'entreprise.",
          },
          giftsMealsTravel: {
            title: "4.3.2 Cadeaux, Repas, Voyages et Divertissements",
            content:
              "Aucun cadeau, repas, voyage ou divertissement ne peut être offert à quiconque (fonctionnaires ou partenaires commerciaux) en échange d'une faveur ou d'un avantage inapproprié. De plus, les cadeaux en espèces ou équivalents à des espèces, tels que les cartes-cadeaux, ne sont pas autorisés.",
          },
          gifts: {
            title: "4.3.3 Cadeaux",
            content:
              "Aucun cadeau ne peut être donné pour influencer indûment un fonctionnaire ou en échange d'une faveur ou d'un avantage inapproprié. Il peut toutefois être permis de faire des dons directement à une agence gouvernementale (plutôt qu'à un fonctionnaire individuel) dans le cadre d'un effort caritatif.",
          },
          promotionDemonstration: {
            title: "4.3.4 Promotion, démonstration ou explication de produits",
            content:
              "Aucune dépense ou activité publicitaire ne peut être dirigée vers un fonctionnaire pour l'influencer indûment ou en retour d'une faveur ou d'un avantage inapproprié. Dans certaines circonstances, cependant, il peut être approprié de diriger de telles dépenses vers un fonctionnaire ou une entité afin de promouvoir, démontrer ou expliquer les produits et services de l'entreprise.",
          },
          hiringGovernmentOfficials: {
            title: "4.3.5 Embauche ou Emploi de Fonctionnaires",
            content:
              "Aucun fonctionnaire ou membre de sa famille immédiate ne peut être embauché ou employé pour influencer indûment l'employé ou en retour d'une faveur ou d'un avantage inapproprié. Veuillez noter qu'avant d'embaucher un fonctionnaire (ou son parent), les associés de l'entreprise doivent d'abord obtenir l'approbation juridique.",
          },
          politicalContributions: {
            title: "4.3.6 Contributions Politiques",
            content:
              "Aucune contribution politique ne peut être faite pour influencer indûment un fonctionnaire ou en échange d'une faveur ou d'un avantage inapproprié.",
          },
        },
        thirdPartyManagement: {
          title: "4.4 Gestion des Tiers",
          applicability: {
            title: "4.4.1 Applicabilité aux tiers",
            paragraph1:
              "Les agents tiers, consultants, distributeurs ou tout autre représentant tiers agissant pour ou au nom de l'entreprise (collectivement, « Tiers ») sont interdits de faire des Paiements de Corruption au nom de l'entreprise. Cette interdiction s'applique également aux sous-traitants embauchés par des tiers pour effectuer des travaux au nom de l'entreprise.",
            paragraph2:
              "Tous les paiements effectués à des tiers, y compris les commissions, les remboursements, les remboursements, doivent être habituels et raisonnables par rapport aux services fournis et doivent être documentés avec précision dans les livres et registres de l'entreprise. Aucun paiement de ce type ne doit être effectué en espèces ou sur des comptes bancaires qui ne sont pas au nom du tiers.",
          },
          dueDiligence: {
            title: "4.4.2 Diligence Raisonnable",
            paragraph1:
              "Tous les tiers qui interagiront avec des fonctionnaires ou des entités au nom de l'entreprise doivent compléter le processus de diligence raisonnable de l'entreprise avant de commencer à travailler au nom de l'entreprise. Les Documents de Procédure fournissent un aperçu détaillé du processus de diligence raisonnable des tiers.",
            paragraph2:
              "Tous les drapeaux rouges soulevés lors d'un audit de diligence raisonnable d'un fournisseur doivent être traités à la satisfaction du Conseiller Juridique de l'entreprise avant d'entrer dans une relation avec le tiers et toute action corrective mise en œuvre doit être documentée dans l'outil de diligence raisonnable. Les Documents de Procédure contiennent des informations supplémentaires concernant les drapeaux rouges tiers courants. Il est important de noter que la diligence raisonnable doit être renouvelée pour les fournisseurs actifs tous les trois ans.",
            paragraph3:
              "Tous les accords avec des tiers interagissant avec des agences ou des fonctionnaires gouvernementaux doivent être écrits et inclure un langage anti-corruption approprié. Le conseiller juridique de l'entreprise déterminera le langage contractuel approprié.",
            paragraph4:
              "Une fois qu'un agent ou consultant tiers est acquis par l'entreprise, les activités et dépenses du tiers doivent être surveillées par le responsable de l'entreprise concerné pour assurer la conformité continue aux lois anti-corruption applicables et aux politiques de l'entreprise.",
          },
        },
        education: {
          title: "4.5 Formation",
          paragraph1:
            "L'entreprise exige que tous les administrateurs et tous les employés suivent une formation anti-corruption tous les deux ans.",
          paragraph2:
            "La formation anti-corruption requise peut inclure une formation en personne ou en ligne, un cours de formation anti-corruption en ligne ou des programmes de formation dirigés par un instructeur. Si un associé de l'entreprise se voit attribuer un cours de formation en ligne, il ou elle doit compléter ce cours en ligne, qu'il ou elle ait également reçu une formation en personne.",
        },
        audit: {
          title: "4.7 Audit",
          content:
            "Les employés de l'entreprise effectueront des audits internes périodiques des opérations pertinentes de l'entreprise pour assurer la conformité continue de l'entreprise aux lois anti-corruption applicables et à cette Politique. Il est du devoir de tous les employés de coopérer avec - et de ne jamais interférer avec ou entraver - de telles activités d'audit ou enquêtes de l'entreprise. Les auditeurs de l'entreprise sont censés agir de manière indépendante et contacter le Conseiller Juridique de l'entreprise pour clarification de toute question concernant l'application de cette Politique.",
        },
        reportingViolations: {
          title: "4.8 Signalement des Violations",
          content:
            "Si vous observez une conduite pouvant violer cette Politique, contactez le Conseiller Juridique de l'entreprise ou utilisez compliance@vidavo.eu. Les violations présumées seront examinées et feront l'objet d'une enquête appropriée et peuvent entraîner des mesures disciplinaires. Tout rapport de ce type sera traité comme confidentiel dans la mesure permise par la loi. L'entreprise interdit strictement les représailles pour les signalements de bonne foi de conduite suspecte. Le défaut de signaler une violation de cette Politique constitue une violation indépendante de cette Politique passible de mesures disciplinaires, y compris, mais sans s'y limiter, le licenciement.",
        },
      },
      managingDirector: "Directrice Générale",
      name: "Markella Psymarnou",
    },
  },
  cookies: {
    banner: {
      title: "Nous utilisons des cookies",
      description:
        'Ce site web utilise des cookies pour améliorer votre expérience de navigation et fournir du contenu personnalisé. En cliquant sur "Tout accepter", vous acceptez notre utilisation des cookies.',
      acceptAll: "Tout accepter",
      necessaryOnly: "Nécessaires uniquement",
      settings: "Paramètres",
    },
    dialog: {
      title: "Préférences des cookies",
      description:
        "Choisissez les cookies que vous souhaitez accepter. Vous pouvez modifier ces paramètres à tout moment.",
      necessary: {
        label: "Cookies nécessaires",
        description: "Requis pour que le site web fonctionne correctement. Ces cookies ne peuvent pas être désactivés.",
      },
      analytics: {
        label: "Cookies analytiques",
        description: "Nous aident à comprendre comment les visiteurs utilisent notre site web",
      },
      cancel: "Annuler",
      savePreferences: "Enregistrer les préférences",
    },
  },
  common: {
    learnMore: "En savoir plus",
  },
  vida24HomeCare: {
    meta: {
      title: "Vida24 pour les soins à domicile | Télésurveillance pour structures de soins",
      description: "Vida24 aide les équipes soignantes à recueillir les signes vitaux, à surveiller l'état de santé en temps réel et à coordonner les actions de soins au sein d'une plateforme connectée unique.",
      ogTitle: "Vida24 — Télésurveillance pour les soins à domicile, les EHPAD et les établissements de santé",
      ogDescription: "Une plateforme connectée pour la saisie des signes vitaux, la surveillance en temps réel et la coordination des soins.",
    },
    hero: {
      titlePrefix: "Télésurveillance pour",
      titleItems: ["les soins à domicile", "les EHPAD", "les établissements de santé"],
      subtitle: "Vida24 aide les équipes soignantes à recueillir les signes vitaux, à surveiller l'état de santé en temps réel et à coordonner les actions de soins au sein d'une plateforme connectée unique.",
      requestDemo: "Demander une démo",
    },
    benefits: [
      { title: "Des soins dans l'environnement familier", text: "Une prise en charge continue à domicile et en établissement de soins." },
      { title: "Surveillance en temps réel", text: "Recueil des signes vitaux en temps réel et détection précoce des changements." },
      { title: "Meilleurs résultats et qualité de vie", text: "Réponse plus rapide, moins d'aggravations et meilleure qualité de vie." },
      { title: "Soins connectés et coordonnés", text: "Équipes soignantes, médecins et établissements travaillent ensemble sur une seule plateforme." },
    ],
    howItWorks: {
      title: "Comment fonctionne Vida24 ?",
      steps: [
        { title: "Mesurer", text: "Les patients ou les professionnels de santé recueillent les signes vitaux à l'aide de dispositifs médicaux connectés, à domicile ou en établissement." },
        { title: "Transmettre", text: "Les données sont transmises en toute sécurité à la plateforme Vida24 via une connectivité Bluetooth." },
        { title: "Documenter", text: "Les mesures sont automatiquement associées au dossier patient, garantissant une documentation complète et précise." },
        { title: "Visualiser", text: "Les professionnels de santé disposent d'une visibilité immédiate sur l'état de santé, les tendances et les alertes via un tableau de bord centralisé." },
        { title: "Réagir", text: "Les équipes soignantes peuvent réagir rapidement, coordonner les interventions et assurer une prise en charge continue à partir d'informations en temps réel." },
      ],
    },
    devices: {
      title: "Dispositifs médicaux connectés",
      subtitle: "Vida24 prend en charge l'intégration d'une large gamme de dispositifs médicaux Bluetooth pour la surveillance à distance et les soins connectés.",
      items: [
        { name: "Lecteur de glycémie", detail: "Accu-Chek Instant" },
        { name: "Tensiomètre", detail: "Suivi continu de la tension" },
        { name: "Thermomètre", detail: "Température corporelle" },
        { name: "Spiromètre", detail: "Capacité respiratoire" },
        { name: "Dispositif ECG", detail: "D-Heart" },
      ],
    },
    capabilities: {
      title: "Fonctionnalités de la plateforme",
      items: [
        { title: "Solution de tableau de bord cloud", text: "Accès sécurisé à tout moment, où que vous soyez." },
        { title: "Compatible avec les logiciels de soins existants", text: "Intégration fluide dans vos flux de travail." },
        { title: "Compatible avec les dispositifs Bluetooth et de signes vitaux", text: "Un écosystème de dispositifs fiable et évolutif." },
      ],
    },
    audiences: {
      title: "À qui s'adresse Vida24 ?",
      subtitle: "Conçu pour accompagner les professionnels de santé, les organisations de santé et les particuliers grâce aux soins connectés et à la télésurveillance.",
      prev: "Public précédent",
      next: "Public suivant",
      slide: "Aller à la diapositive",
      items: [
        { title: "Pour les équipes soignantes", items: ["Recueillir facilement les signes vitaux", "Coordonner les actions de soins", "Garder les patients sous surveillance"] },
        { title: "Pour les prestataires et organisations", items: ["Vue centralisée des patients", "Meilleure coordination et allocation", "Flux de surveillance évolutifs"] },
        { title: "Pour les patients et résidents", items: ["Soins dans l'environnement familier", "Soutien de surveillance continue", "Meilleur lien avec l'équipe soignante"] },
      ],
    },
    reasons: {
      title: "Pourquoi les organisations choisissent Vida24",
      items: [
        { title: "Plateforme de télésurveillance éprouvée", text: "Soutient les flux de soins connectés et de surveillance à distance." },
        { title: "Multiples intégrations de dispositifs", text: "Compatible avec une large gamme de dispositifs médicaux Bluetooth." },
        { title: "Gestion centralisée des soins", text: "Une seule plateforme pour la surveillance, la coordination et la documentation." },
        { title: "Évolutive sur tous les contextes de soins", text: "Adaptée aux soins à domicile, aux EHPAD et aux établissements de santé." },
      ],
    },
    cta: {
      title: "Prêt à découvrir Vida24 ?",
      subtitle: "Discutons de la manière dont les soins connectés et la télésurveillance peuvent soutenir votre organisation.",
      demo: "Demander une démo",
      pilot: "Lancer un pilote",
      contact: "Nous contacter",
    },
    contactModal: {
      titles: { demo: "Demander une démo", general: "Demande générale", pilot: "Programme pilote" },
      subtitle: "Découvrez comment Vida24 peut soutenir votre organisation grâce aux soins connectés et à la télésurveillance.",
      labels: {
        firstName: "Prénom",
        lastName: "Nom",
        organization: "Organisation",
        jobTitle: "Fonction",
        country: "Pays",
        email: "E-mail",
        phone: "Téléphone",
        message: "Message",
      },
      close: "Fermer le formulaire",
      submit: "Envoyer la demande",
    },
  },
};
